import { calculateWideningFromRadius } from "utilities/genericRoadUtilities/calculateWideningFromRadius";


export const calculateWideningFromHorizontalData = (geometry, laneWidth, speedlimit, vehicle) => {

    let extraWidening = [];
    let tempExtraWidening = [];
    
    let tempGeometry = [];
    for(let i = 0; i<geometry.length; i++)
    {
        if(tempGeometry.length === 0)
        {
            tempGeometry.push(geometry[i]);
            continue;
        }
        if(geometry[i].type === "Rettlinje" && tempGeometry[tempGeometry.length-1].type === "Rettlinje")
        {
            tempGeometry[tempGeometry.length-1].endStationing = geometry[i].endStationing;
            tempGeometry[tempGeometry.length-1].length += geometry[i].length;
        }
        /*else if(geometry[i].type === "Sirkelbue" && tempGeometry[tempGeometry.length-1].type === "Sirkelbue")
        {
            if(geometry[i].firstRadius === tempGeometry[tempGeometry.length-1].firstRadius)
            {
                tempGeometry[tempGeometry.length-1].endStationing = geometry[i].endStationing;
                tempGeometry[tempGeometry.length-1].length += geometry[i].length;
            }
            else
            {
                tempGeometry.push(geometry[i]);
            }
        }*/
        else
        {
            tempGeometry.push(geometry[i]);
        }
    }
    geometry = tempGeometry;

    // #region inserting points
    if(geometry.length >= 3)
    {
        for(let i = 1; i<geometry.length-1; i++)
        {
            let O1 = geometry[i-1];
            let O2 =geometry[i];
            let O3 =geometry[i+1];

            if(O1.type === "Rettlinje" && O2.type === "Klotoide" && O3.type === "Klotoide")
            {
                if(Math.abs(O2.secondRadius) <= 500)
                {
                    //let firstExtraWidth = 0;
                    let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);

                    //let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    extraWidening.push(A2);
                } 
            }
            else if(O1.type === "Rettlinje" && O2.type === "Klotoide" && O3.type === "Sirkelbue")
            {
                if(Math.abs(O2.secondRadius) <= 500)
                {
                    let firstExtraWidth = 0;
                    let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);

                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    extraWidening.push(A1, A2);
                }
            }
            else if(O1.type === "Rettlinje" && O2.type === "Sirkelbue" && O3.type === "Rettlinje")
            {
                if(Math.abs(O2.firstRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);

                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                    
                    extraWidening.push(A1, A2);
                }
                
            }
            else if(O1.type === "Rettlinje" && O2.type === "Sirkelbue" && O3.type === "Klotoide")
            {
                if(Math.abs(O2.firstRadius) <= 500)
                {
                    
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);

                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};
                    extraWidening.push(A1, A2);
                }
                
            }
            else if(O1.type === "Rettlinje" && O2.type === "Sirkelbue" && O3.type === "Sirkelbue")
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O3.firstRadius, vehicle, laneWidth);

                if(Math.abs(O2.firstRadius) <= 500 && Math.abs(O3.firstRadius) <= 500)
                {
                    if(Math.abs(O2.firstRadius) > Math.abs(O3.firstRadius))
                    {
                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                        let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: firstExtraWidth};
                        let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                        
                        if(A1.stationing < A2.stationing) extraWidening.push(A1, A2, A3);
                        else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
                    }
                    else if(Math.abs(O2.firstRadius) < Math.abs(O3.firstRadius))
                    {
                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                        let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};
                        
                        extraWidening.push(A1, A2);
                    }
                }
                else if(Math.abs(O2.firstRadius) > 500 && Math.abs(O3.firstRadius) <= 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: 0};
                    let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: 0};
                    let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    if(A1.stationing < A2.stationing) extraWidening.push(A2, A3);
                    else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);

                }
                else if(Math.abs(O2.firstRadius) <= 500 && Math.abs(O3.firstRadius) > 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};
                    
                    extraWidening.push(A1, A2);
                }   
            }

            //=====================================================================================

            else if(O1.type === "Klotoide" && O2.type === "Rettlinje" && O3.type === "Klotoide")
            {
                if(Math.abs(O1.firstRadius) <= 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: 0};
                    extraWidening.push(A1);
                }

                if(Math.abs(O3.secondRadius) <= 500)
                {
                    let A2 = {stationing: O2.endStationing, extraWidth: 0};
                    extraWidening.push(A2);
                }    
            }
            else if(O1.type === "Klotoide" && O2.type === "Rettlinje" && O3.type === "Sirkelbue")
            {
                //let firstExtraWidth = calculateWideningFromRadius(O1.secondRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O3.firstRadius, vehicle, laneWidth);

                if(O1.firstRadius <= 500 && O3.firstRadius <= 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: 0};
                    let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: 0};
                    let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                    
                    if(A1.stationing < A2.stationing) extraWidening.push(A2, A3);
                    else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
                }
                else if(O1.secondRadius > 500 && O3.firstRadius <= 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: 0};
                    let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: 0};
                    let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                    
                    if(A1.stationing < A2.stationing) extraWidening.push(A2, A3);
                    else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
                }
                else if(O1.secondRadius <= 500 && O3.firstRadius > 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: 0};
                    let A3 = {stationing: O2.endStationing, extraWidth: 0};

                    extraWidening.push(A1, A3);
                }
                
            }
            else if(O1.type === "Klotoide" && O2.type === "Klotoide" && O3.type === "Rettlinje")
            {
                if(Math.abs(O2.firstRadius <= 500))
                {
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: 0};
                    extraWidening.push(A1, A2);
                }
            }
            else if(O1.type === "Klotoide" && O2.type === "Klotoide" && O3.type === "Klotoide")
            {
                if( Math.abs(O1.firstRadius) > 0 && Math.abs(O1.firstRadius) <= 500 &&
                    Math.abs(O1.secondRadius) === 0 && Math.abs(O2.firstRadius) === 0 &&
                    Math.abs(O2.secondRadius) > 0 && Math.abs(O2.secondRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);
                    let minimiumExtraWidth = Math.min(0.5 * firstExtraWidth, 0.5 * secondExtraWidth);

                    let intersectionStationing = (minimiumExtraWidth - secondExtraWidth + O2.endStationing * ((secondExtraWidth - 0)/(O2.endStationing - O2.startStationing)))/((secondExtraWidth - 0)/(O2.endStationing - O2.startStationing));

                    let A1 = {stationing: intersectionStationing, extraWidth: minimiumExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                    extraWidening.push(A1, A2);
                }
                else if(Math.abs(O2.firstRadius) > 0 && Math.abs(O2.firstRadius) <= 500 &&
                        Math.abs(O2.secondRadius) === 0 && Math.abs(O3.firstRadius) === 0 &&
                        Math.abs(O3.secondRadius) > 0 && Math.abs(O3.secondRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = calculateWideningFromRadius(O3.secondRadius, vehicle, laneWidth);
                    let minimiumExtraWidth = Math.min(0.5 * firstExtraWidth, 0.5 * secondExtraWidth);

                    let intersectionStationing = (minimiumExtraWidth - firstExtraWidth + O2.startStationing * ((0 - firstExtraWidth)/(O2.endStationing - O2.startStationing)))/((0 - firstExtraWidth)/(O2.endStationing - O2.startStationing));
                    
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: intersectionStationing, extraWidth: minimiumExtraWidth};

                    extraWidening.push(A1, A2);
                }
                else
                {
                    if(Math.abs(O2.firstRadius) <= 500)
                    {
                        let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                        extraWidening.push(A1);
                    }

                    if(Math.abs(O2.secondRadius) <= 500)
                    {
                        let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);
                        let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                        extraWidening.push(A2);
                    }
                }
            }
            else if(O1.type === "Klotoide" && O2.type === "Klotoide" && O3.type === "Sirkelbue")
            {
                if( Math.abs(O1.firstRadius) > 0 && Math.abs(O1.firstRadius) <= 500 &&
                    Math.abs(O1.secondRadius) === 0 && Math.abs(O2.firstRadius) === 0 &&
                    Math.abs(O2.secondRadius) > 0 && Math.abs(O2.secondRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);
                    let minimiumExtraWidth = Math.min(0.5 * firstExtraWidth, 0.5 * secondExtraWidth);

                    let intersectionStationing = (minimiumExtraWidth - secondExtraWidth + O2.endStationing * ((secondExtraWidth - 0)/(O2.endStationing - O2.startStationing)))/((secondExtraWidth - 0)/(O2.endStationing - O2.startStationing));

                    let A1 = {stationing: intersectionStationing, extraWidth: minimiumExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                    extraWidening.push(A1, A2);
                }
                else
                {
                    if((Math.abs(O2.firstRadius) <= 500 && Math.abs(O2.firstRadius) !== 0) || (Math.abs(O2.secondRadius) <= 500 && Math.abs(O2.secondRadius) !== 0))
                    {
                        let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                        let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);

                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                        let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                        extraWidening.push(A1, A2);
                    }
                }
            }
            else if(O1.type === "Klotoide" && O2.type === "Sirkelbue" && O3.type === "Rettlinje")
            {
                if(Math.abs(O2.firstRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);

                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};
                    
                    extraWidening.push(A1, A2);
                }
                
            }
            else if(O1.type === "Klotoide" && O2.type === "Sirkelbue" && O3.type === "Klotoide")
            {
                if(Math.abs(O2.firstRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);

                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};
                    
                    extraWidening.push(A1, A2);
                }
            }
            else if(O1.type === "Klotoide" && O2.type === "Sirkelbue" && O3.type === "Sirkelbue")
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O3.firstRadius, vehicle, laneWidth);

                if(Math.abs(O2.firstRadius) <= 500)
                {
                    if(Math.abs(O3.firstRadius) <= 500)
                    {
                        if(Math.abs(O2.firstRadius) > Math.abs(O3.firstRadius))
                        {
                            let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                            let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: firstExtraWidth};
                            let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                            
                            if(A1.stationing < A2.stationing) extraWidening.push(A2, A3);
                            else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
                        }
                        else if(Math.abs(O2.firstRadius) <= Math.abs(O3.firstRadius))
                        {
                            let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                            let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};
                            
                            extraWidening.push(A1, A2);
                        }
                    }
                    else if(Math.abs(O3.firstRadius) > 500)
                    {
                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth}
                        let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};

                        extraWidening.push(A1, A2);
                    }
                }
                else if(Math.abs(O2.firstRadius) > 500)
                {
                    if(Math.abs(O3.firstRadius) <= 500)
                    {
                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                        let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: firstExtraWidth};
                        let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                        
                        if(A1.stationing < A2.stationing) extraWidening.push(A2, A3);
                        else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
                    }
                }
            }

            //=====================================================================================

            else if(O1.type === "Sirkelbue" && O2.type === "Rettlinje" && O3.type === "Klotoide")
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                //let secondExtraWidth = calculateWideningFromRadius(O3.secondRadius, vehicle, laneWidth);

                if(Math.abs(O1.firstRadius) <= 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: 0};
                    let A3 = {stationing: O2.endStationing, extraWidth: 0};

                    if(Math.abs(O3.secondRadius) <= 500)
                    {
                        if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                        else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                    }
                    else if(Math.abs(O3.secondRadius) > 500)
                    {
                        if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                        else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3); 
                    }
                }
                else if(Math.abs(O1.firstRadius) > 500 && Math.abs(O3.secondRadius) <= 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    extraWidening.push(A1);
                }
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Rettlinje" && O3.type === "Sirkelbue")
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O3.firstRadius, vehicle, laneWidth);

                if(Math.abs(O1.firstRadius) <= 500 && Math.abs(O3.firstRadius) > 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: 0};
                    let A3 = {stationing: O2.endStationing, extraWidth: 0};
                    
                    if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                    else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                }
                else if(Math.abs(O1.firstRadius) > 500 && Math.abs(O3.firstRadius) <= 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: 0};
                    let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: secondExtraWidth};
                    let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    if(A1.stationing < A2.stationing) extraWidening.push(A2, A3);
                    else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
                }
                else if(Math.abs(O1.firstRadius) <= 500 && Math.abs(O3.firstRadius) <= 500)
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: 0};
                    let A3 = {stationing: O2.endStationing - speedlimit/3, extraWidth: 0};
                    let A4 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                    if(A2.stationing < A3.stationing) extraWidening.push(A1, A2, A3, A4);

                    else if(A2.stationing >= A3.stationing)
                    {
                        let crossProduct = (A2.stationing - A1.stationing) * (A4.extraWidth - A3.extraWidth) - (A2.extraWidth - A1.extraWidth) * (A4.stationing - A3.stationing);
                        if(crossProduct > 2e-8)
                        {
                            let intersectionStationing = ((A1.stationing * (A2.extraWidth - A1.extraWidth)/(A2.stationing - A1.stationing)) - (A3.stationing * (A4.extraWidth - A3.extraWidth)/(A4.stationing - A3.stationing)) - A1.extraWidth + A3.extraWidth)/(((A2.extraWidth - A1.extraWidth)/(A2.stationing - A1.stationing)) - ((A4.extraWidth - A3.extraWidth)/(A4.stationing - A3.stationing)));
                            if(intersectionStationing > O2.startStationing && intersectionStationing < O2.endStationing)
                            {
                                let intersectionExtraWidth = ((A2.extraWidth - A1.extraWidth)/(A2.stationing - A1.stationing)) * (intersectionStationing - A1.stationing) + A1.extraWidth;
                                extraWidening.push(A1, {stationing: intersectionStationing, extraWidth: intersectionExtraWidth}, A4);
                            }
                            else extraWidening.push(A1, A4);
                        }
                        else extraWidening.push(A1, A4);
                    }
                }   
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Klotoide" && O3.type === "Rettlinje")
            {
                if(Math.abs(O2.firstRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = 0;

                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    extraWidening.push(A1, A2);
                }
                
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Klotoide" && O3.type === "Klotoide")
            {
                if( Math.abs(O2.firstRadius) > 0 && Math.abs(O2.firstRadius) <= 500 &&
                    Math.abs(O2.secondRadius) === 0 && Math.abs(O3.firstRadius) === 0 &&
                    Math.abs(O3.secondRadius) > 0 && Math.abs(O3.secondRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = calculateWideningFromRadius(O3.secondRadius, vehicle, laneWidth);
                    let minimiumExtraWidth = Math.min(0.5 * firstExtraWidth, 0.5 * secondExtraWidth);

                    let intersectionStationing = (minimiumExtraWidth - firstExtraWidth + O2.startStationing * ((0 - firstExtraWidth)/(O2.endStationing - O2.startStationing)))/((0 - firstExtraWidth)/(O2.endStationing - O2.startStationing));
                    
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: intersectionStationing, extraWidth: minimiumExtraWidth};

                    extraWidening.push(A1, A2);
                }
                else
                {
                    if(Math.abs(O2.firstRadius) <= 500)
                    {
                        let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                        extraWidening.push(A1);
                    }

                    if(Math.abs(O2.firstRadius) <= 500)
                    {
                        let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);
                        let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                        extraWidening.push(A2);
                    }
                }
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Klotoide" && O3.type === "Sirkelbue")
            {
                if(Math.abs(O2.firstRadius) <= 500 || Math.abs(O2.secondRadius) <= 500)
                {
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);

                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    extraWidening.push(A1, A2)
                }                
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Sirkelbue" && O3.type === "Rettlinje")
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);

                if(Math.abs(O2.firstRadius) <= 500)
                {
                    if(Math.abs(O1.firstRadius) <= 500)
                    {
                        if(Math.abs(O1.firstRadius) > Math.abs(O2.firstRadius))
                        {
                            let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                            let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                            extraWidening.push(A1, A2);
                        }
                        else if(Math.abs(O1.firstRadius) < Math.abs(O2.firstRadius))
                        {
                            
                            let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                            let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: secondExtraWidth};
                            let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                            if(A2.stationing < A3.stationing) extraWidening.push(A1, A2, A3);
                            else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                        }
                    }
                    else if(Math.abs(O1.firstRadius) > 500)
                    {
                        let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                        let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                        extraWidening.push(A1, A2);
                    }
                }
                else if(Math.abs(O2.firstRadius) > 500)
                {
                    if(Math.abs(O1.firstRadius) <= 500)
                    {
                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                        let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: 0};
                        let A3 = {stationing: O2.endStationing, extraWidth: 0};

                        if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                        else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                    }
                }     
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Sirkelbue" && O3.type === "Klotoide")
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);

                if(Math.abs(O2.firstRadius) <= 500)
                {
                    if(Math.abs(O1.firstRadius) <= 500)
                    {
                        if(Math.abs(O1.firstRadius) > Math.abs(O2.firstRadius))
                        {
                            let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                            let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                            extraWidening.push(A1, A2);
                            
                        }
                        else if(Math.abs(O1.firstRadius) < Math.abs(O2.firstRadius))
                        {
                            let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                            let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: secondExtraWidth};
                            let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                            if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                            else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                        }
                    }
                    else if(Math.abs(O1.firstRadius) > 500)
                    {
                        let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                        let A2 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};

                        extraWidening.push(A1, A2);
                    }
                }
                else if(Math.abs(O2.firstRadius) > 500)
                {

                    if(Math.abs(O1.firstRadius) <= 500)
                    {
                        let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                        let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: secondExtraWidth};
                        let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                        if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                        else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                    }
                }
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Sirkelbue" && O3.type === "Sirkelbue")
            {
                
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                let thirdExtraWidth = calculateWideningFromRadius(O3.firstRadius, vehicle, laneWidth);
                
                if(Math.abs(O1.firstRadius) === Math.abs(O2.firstRadius) && Math.abs(O2.firstRadius) < Math.abs(O3.firstRadius))
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                    extraWidening.push(A1, A2);
                }
                else if(Math.abs(O1.firstRadius) === Math.abs(O2.firstRadius) && Math.abs(O2.firstRadius) > Math.abs(O3.firstRadius))
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                    let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: secondExtraWidth};
                    let A3 = {stationing: O2.endStationing, extraWidth: thirdExtraWidth};

                    if(A1.stationing < A2.stationing) extraWidening.push(A2, A3);
                    else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
                }
                else if(Math.abs(O1.firstRadius) < Math.abs(O2.firstRadius) && Math.abs(O2.firstRadius) === Math.abs(O3.firstRadius))
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: secondExtraWidth};
                    let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                    if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                }
                else if(Math.abs(O1.firstRadius) > Math.abs(O2.firstRadius) && Math.abs(O2.firstRadius) === Math.abs(O3.firstRadius))
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};
                    extraWidening.push(A1, A2);
                }
                else if(Math.abs(O1.firstRadius) < Math.abs(O2.firstRadius) && Math.abs(O2.firstRadius) < Math.abs(O3.firstRadius))
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: secondExtraWidth};
                    let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    if(A1.stationing < A2.stationing) extraWidening.push(A2, A3);
                    else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
                }
                else if(Math.abs(O1.firstRadius) < Math.abs(O2.firstRadius) && Math.abs(O2.firstRadius) > Math.abs(O3.firstRadius))
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: secondExtraWidth};
                    let A3 = {stationing: O2.endStationing - speedlimit/3, extraWidth: secondExtraWidth};
                    let A4 = {stationing: O2.endStationing, extraWidth: thirdExtraWidth};

                    if(A2.stationing < A3.stationing) extraWidening.push(A1, A2, A3, A4);
                    else if(A2.stationing >= A3.stationing)
                    {
                        let crossProduct = (A2.stationing - A1.stationing) * (A4.extraWidth - A3.extraWidth) - (A2.extraWidth - A1.extraWidth) * (A4.stationing - A3.stationing);
                        if(crossProduct > 2e-8)
                        {
                            let intersectionStationing = ((A1.stationing * (A2.extraWidth - A1.extraWidth)/(A2.stationing - A1.stationing)) - (A3.stationing * (A4.extraWidth - A3.extraWidth)/(A4.stationing - A3.stationing)) - A1.extraWidth + A3.extraWidth)/(((A2.extraWidth - A1.extraWidth)/(A2.stationing - A1.stationing)) - ((A4.extraWidth - A3.extraWidth)/(A4.stationing - A3.stationing)));
                            let intersectionExtraWidth = ((A2.extraWidth - A1.extraWidth)/(A2.stationing - A1.stationing)) * (intersectionStationing - A1.stationing) + A1.extraWidth;

                            if(intersectionStationing > O2.startStationing && intersectionStationing < O2.endStationing)
                            {
                                extraWidening.push(A1, {stationing: intersectionStationing, extraWidth: intersectionExtraWidth}, A4);
                            }
                            else
                            {
                                extraWidening.push(A1, A4);
                            }
                        }
                        else
                        {
                            extraWidening.push(A1, A4);
                        }
                    }
                }
                else if(Math.abs(O1.firstRadius) > Math.abs(O2.firstRadius) && Math.abs(O2.firstRadius) < Math.abs(O3.firstRadius))
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    extraWidening.push(A1, A2);
                }
                else if(Math.abs(O1.firstRadius) > Math.abs(O2.firstRadius) && Math.abs(O2.firstRadius) > Math.abs(O3.firstRadius))
                {
                    let A1 = {stationing: O2.startStationing, extraWidth: secondExtraWidth};
                    let A2 = {stationing: O2.endStationing - speedlimit/3, extraWidth: thirdExtraWidth};
                    let A3 = {stationing: O2.endStationing, extraWidth: thirdExtraWidth};

                    if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                    else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                    if(Math.abs(O1.firstRadius) <= 500 && Math.abs(O2.firstRadius) <= 500 && Math.abs(O3.firstRadius) <= 500) {}
                    else if(Math.abs(O1.firstRadius) > 500 && Math.abs(O2.firstRadius) <= 500 && Math.abs(O3.firstRadius) <= 500) {}
                    else if(Math.abs(O1.firstRadius) > 500 && Math.abs(O2.firstRadius) > 500 && Math.abs(O3.firstRadius) <= 500) {}
                }
            }
        }
    }
    // #endregion

    // #region inserting startpoints
    if(geometry.length >= 2)
    {
        let O1 = geometry[0];
        let O2 = geometry[1];
        if(O1.type === "Rettlinje" && O2.type === "Klotoide")
        {
            /*if(Math.abs(O2.secondRadius) <= 500)
            {
                let A1 = {stationing: O1.endStationing, extraWidth: 0};
                extraWidening.unshift(A1);
            }*/
        }
        else if(O1.type === "Rettlinje" && O2.type === "Sirkelbue")
        {
            if(Math.abs(O2.secondRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);

                let A1 = {stationing: O1.startStationing, extraWidth: 0};
                let A2 = {stationing: O1.endStationing - speedlimit/3, extraWidth: 0};
                let A3 = {stationing: O1.endStationing, extraWidth: firstExtraWidth};

                if(A1.stationing < A2.stationing) extraWidening.unshift(A2, A3);
                else if(A1.stationing >= A2.stationing) extraWidening.unshift(A1, A3);
            }
        }
        else if(O1.type === "Klotoide" && O2.type === "Rettlinje")
        {
            if(Math.abs(O1.firstRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let A1 = {stationing: O1.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O1.endStationing, extraWidth: 0};

                extraWidening.unshift(A1, A2);
            }
        }
        else if(O1.type === "Klotoide" && O2.type === "Klotoide")
        {
            if((Math.abs(O1.firstRadius) <= 500 && Math.abs(O1.firstRadius) !== 0) || (Math.abs(O1.secondRadius) <= 500 && Math.abs(O1.secondRadius) !== 0) )
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O1.secondRadius, vehicle, laneWidth);

                let A1 = {stationing: O1.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O1.endStationing, extraWidth: secondExtraWidth};

                extraWidening.unshift(A1, A2);
            }
        }
        else if(O1.type === "Klotoide" && O2.type === "Sirkelbue")
        {
            if((Math.abs(O1.firstRadius) <= 500 && Math.abs(O1.firstRadius) !== 0) || Math.abs(O1.secondRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O1.secondRadius, vehicle, laneWidth);

                let A1 = {stationing: O1.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O1.endStationing, extraWidth: secondExtraWidth};
                
                extraWidening.unshift(A1, A2);
            }
        }
        else if(O1.type === "Sirkelbue" && O2.type === "Rettlinje")
        {
            if(Math.abs(O1.firstRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let A1 = {stationing: O1.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O1.endStationing, extraWidth: firstExtraWidth};
                
                extraWidening.unshift(A1, A2);
            }
        }
        else if(O1.type === "Sirkelbue" && O2.type === "Klotoide")
        {
            if(Math.abs(O1.firstRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let A1 = {stationing: O1.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O1.endStationing, extraWidth: firstExtraWidth};
                
                extraWidening.unshift(A1, A2);
            }
        }
        else if(O1.type === "Sirkelbue" && O2.type === "Sirkelbue")
        {
            if(Math.abs(O1.firstRadius) <= 500 && Math.abs(O2.firstRadius) <= 500)
            {
                if(Math.abs(O1.firstRadius) <= Math.abs(O2.firstRadius))
                {
                    
                    let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);

                    let A1 = {stationing: O1.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O1.endStationing, extraWidth: firstExtraWidth};

                    extraWidening.unshift(A1, A2);
                    
                }
                else if(Math.abs(O1.firstRadius) > Math.abs(O2.firstRadius))
                {
                    let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                
                    let A1 = {stationing: O1.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O1.endStationing - speedlimit/3, extraWidth: firstExtraWidth};
                    let A3 = {stationing: O1.endStationing, extraWidth: secondExtraWidth};

                    if(A1.stationing < A2.stationing) extraWidening.unshift(A1, A2);
                    else if(A1.stationing >= A2.stationing) extraWidening.unshift(A1, A3);
                }
            }
            else if(Math.abs(O1.firstRadius) <= 500 && Math.abs(O2.firstRadius) > 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);

                let A1 = {stationing: O1.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O1.endStationing, extraWidth: firstExtraWidth};

                extraWidening.unshift(A1, A2);
            }
            else if(Math.abs(O1.firstRadius) > 500 && Math.abs(O2.firstRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                
                let A1 = {stationing: O1.startStationing, extraWidth: 0};
                let A2 = {stationing: O1.endStationing - speedlimit/3, extraWidth: 0};
                let A3 = {stationing: O1.endStationing, extraWidth: firstExtraWidth};

                if(A1.stationing < A2.stationing) extraWidening.unshift(A2, A3);
                else if(A1.stationing >= A2.stationing) extraWidening.unshift(A1, A3);
            }
        }

    }
    // #endregion
 
    // #region inserting endpoints
    if(geometry.length >= 2)
    {
        let O1 = geometry[geometry.length-2];
        let O2 = geometry[geometry.length-1];

        if(O1.type === "Rettlinje" && O2.type === "Klotoide")
        {
            if(Math.abs(O2.secondRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);
                let A1 = {stationing: O2.startStationing, extraWidth: 0}
                let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth}

                extraWidening.push(A1, A2);
            }
        }
        else if(O1.type === "Rettlinje" && O2.type === "Sirkelbue")
        {
            if(Math.abs(O2.secondRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth}
                let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth}

                extraWidening.push(A1, A2);
            }
        }
        else if(O1.type === "Klotoide" && O2.type === "Rettlinje")
        {
            /*if(O2.secondRadius <= 500)
            {
                let A1 = {stationing: O2.startStationing, extraWidth: 0}
                let A2 = {stationing: O2.endStationing, extraWidth: 0}

                extraWidening.push(A1, A2);
            }*/
        }
        else if(O1.type === "Klotoide" && O2.type === "Klotoide")
        {
            if((Math.abs(O2.firstRadius) <= 500 && Math.abs(O2.firstRadius) !== 0) || (Math.abs(O2.secondRadius) <= 500 && Math.abs(O2.secondRadius) !== 0) )
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);

                let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                extraWidening.push(A1, A2);
            }
        }
        else if(O1.type === "Klotoide" && O2.type === "Sirkelbue")
        {
            if(Math.abs(O2.secondRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth}
                let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth}

                extraWidening.push(A1, A2);
            }
        }
        else if(O1.type === "Sirkelbue" && O2.type === "Rettlinje")
        {
            if(Math.abs(O2.secondRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: 0};
                let A3 = {stationing: O2.startStationing, extraWidth: 0};

                if(A2.stationing < A3.stationing) extraWidening.push(A1, A2)
                else if(A2.stationing < A3.stationing) extraWidening.push(A1, A3)
            }
        }
        else if(O1.type === "Sirkelbue" && O2.type === "Klotoide")
        {
            if((Math.abs(O2.firstRadius) <= 500 && Math.abs(O2.firstRadius) !== 0) || (Math.abs(O2.secondRadius) <= 500 && Math.abs(O2.secondRadius) !== 0) )
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                let secondExtraWidth = calculateWideningFromRadius(O2.secondRadius, vehicle, laneWidth);

                let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                extraWidening.push(A1, A2);
            }
        }
        else if(O1.type === "Sirkelbue" && O2.type === "Sirkelbue")
        {
            if(Math.abs(O1.firstRadius) <= 500 && Math.abs(O2.firstRadius) <= 500)
            {
                if(Math.abs(O1.firstRadius) >= Math.abs(O2.firstRadius))
                {
                    let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);

                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};

                    extraWidening.push(A1, A2);
                    
                }
                else if(Math.abs(O1.firstRadius) < Math.abs(O2.firstRadius))
                {
                    let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                    let secondExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                
                    let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                    let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: secondExtraWidth};
                    let A3 = {stationing: O2.endStationing, extraWidth: secondExtraWidth};

                    if(A2.stationing < A3.stationing) extraWidening.push(A1, A2);
                    else if(A2.stationing >= A3.stationing) extraWidening.push(A1, A3);
                }
            }
            else if(Math.abs(O1.firstRadius) > 500 && Math.abs(O2.firstRadius) <= 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O2.firstRadius, vehicle, laneWidth);
                let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O2.endStationing, extraWidth: firstExtraWidth};

                extraWidening.push(A1, A2);
            }
            else if(Math.abs(O1.firstRadius) <= 500 && Math.abs(O2.firstRadius) > 500)
            {
                let firstExtraWidth = calculateWideningFromRadius(O1.firstRadius, vehicle, laneWidth);
                
                let A1 = {stationing: O2.startStationing, extraWidth: firstExtraWidth};
                let A2 = {stationing: O2.startStationing + speedlimit/3, extraWidth: 0};
                let A3 = {stationing: O2.endStationing, extraWidth: 0};

                if(A1.stationing < A2.stationing) extraWidening.push(A1, A2);
                else if(A1.stationing >= A2.stationing) extraWidening.push(A1, A3);
            }
        }
    }
    // #endregion

    // #region removing duplicates
    tempExtraWidening = [];

    let lastStationing = null;

    for (let i = 0; i < extraWidening.length; i++)
    {
        let current = extraWidening[i];

        if (current.stationing !== lastStationing)
        {
            tempExtraWidening.push(current);
            lastStationing = current.stationing;
        }
    }

    extraWidening = tempExtraWidening;
    // #region

    // #region checking stationing
    
    let maxDx = speedlimit/3;
    let maxDy = calculateWideningFromRadius(20, vehicle, laneWidth);

    for(let i = 0; i < extraWidening.length-1; i++)
    {
        let dx = Math.abs(extraWidening[i].stationing - extraWidening[i+1].stationing);
        let dy = Math.abs(extraWidening[i].extraWidth - extraWidening[i+1].extraWidth);

        if(dy/dx > maxDy/maxDx)
        {
            extraWidening[i].error = true;
            extraWidening[i+1].error = true;
        }
    }

    // #endregion


    return extraWidening;
}